module.exports = __webpack_public_path__ + "img/listsubject.205d900f.svg";